import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES, VERIFY_MAIL_TYPES } from '@/utils/constants';
import {
  email,
  required,
} from '@/utils/validators';

export default {
  name: 'SendVerifyEmail',
  setup() {
    return { sendMailValidator$: useVuelidate({ $lazy: true }) };
  },
  data() {
    return {
      btnText: '重發驗證信',
      description: '請輸入受邀請的電子郵件地址，以重新發送驗證信',
      email: '',
      snackBarTitle: '帳號驗證連結',
      title: '驗證',
    };
  },
  computed: {
    ...mapState('user', {
      sendingForgetPwdLink: ({ sendingForgetPwdLink }) => sendingForgetPwdLink,
      resending: ({ resending }) => resending,
    }),
    isTypeResetPwd() {
      const type = this.$route?.params?.type;
      return type === VERIFY_MAIL_TYPES.RESET_PASSWORD;
    },
    isTypeSetPwd() {
      const type = this.$route?.params?.type;
      return type === VERIFY_MAIL_TYPES.SET_PASSWORD;
    },
    loading() {
      if (this.isTypeResetPwd) {
        return this.sendingForgetPwdLink;
      }
      return this.resending;
    },
  },
  created() {
    if (this.isTypeResetPwd) {
      this.title = '重設密碼';
      this.btnText = '發送重設密碼連結';
      this.description = '請輸入註冊的電子郵件地址，以重新發送重置密碼信';
      this.snackBarTitle = '重設密碼連結';
    } else if (this.isTypeSetPwd) {
      this.title = '設定密碼';
      this.btnText = '重發設定密碼連結';
      this.description = '請輸入註冊的電子郵件地址，以重新發送重置密碼信';
      this.snackBarTitle = '設定密碼連結';
    }
  },
  methods: {
    ...mapActions('user', {
      resendEmail: 'RESEND_VERIFY_EMAIL',
      sendForgetPwdLink: 'SEND_FORGET_PASSWORD_LINK',
    }),
    async resend() {
      const valid = await this.sendMailValidator$.$validate();
      if (!valid) return;

      try {
        if (this.isTypeResetPwd) {
          await this.sendForgetPwdLink(this.email);
        } else {
          await this.resendEmail(this.email);
        }
        this.$snackbar({ type: SNACKBAR_TYPES.SUCCESS, title: `${this.snackBarTitle}已發送`, msg: '請檢查您的電子信箱。' });
        this.$router.replace('/login');
      } catch (error) {
        const { message: msg } = error;
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: `${this.snackBarTitle}發送失敗`,
          msg,
        });
      }
    },
  },
  validations() {
    return {
      email: { required: required('電子郵件'), email },
    };
  },
};
